<template>
    <div class="row">       
        <span class="col col-grow">
            {{warmingTray.name}}
        </span>
        <span class="col toggle">
            <onoff-toggle v-if="isRealTimeActive(warmingTray)" theme="ios" width="45" height="25" v-model="warmingTray.active" />
            <onoff-toggle v-else-if="isFutureActive(warmingTray)" theme="ios" width="45" onColor="#F39C12" height="25" v-model="warmingTray.active" />
            <onoff-toggle v-else disabled="isHistory(warmingTray)" theme="ios" width="45" height="25"  />
        </span>
        <span class="col text-end"> <translate item="WarmingTray.ActiveFrom" /></span>
        <span class="col">
            <timePicker v-model="warmingTray.activateAt"></timePicker>
        </span>
        <span class="col text-end"><translate item="WarmingTray.ActiveTill" /></span>
        <span class="col">
            <timePicker v-model="warmingTray.deactivateAt"></timePicker>
        </span>
    </div>
</template>

<script>
    import translate from '../components/translate'
    import timemanager from '../repositories/TimeManager';

    export default {

        name: 'WarmingTrayOverlayWarmingTray',

        props: {
            warmingTray: {}
        },

        components: { translate },


        methods: {
            isFutureActive: function (warmingTray) {
                return warmingTray.deactivateAt > timemanager.state.now;
            },

            isRealTimeActive: function (warmingTray) {
                return warmingTray.activateAt < timemanager.state.now && warmingTray.deactivateAt > timemanager.state.now;
            },
            isHistory: function (warmingTray) {
                return warmingTray.deactivateAt < timemanager.state.now;
            }
        },

        watch: {
            'warmingTray.activateAt': function (a, b) {
                if (this.warmingTray.activateAt >= this.warmingTray.deactivateAt) {
                    this.warmingTray.deactivateAt = timemanager.addMinutes(new Date(this.warmingTray.activateAt.getTime()), 5);
                }
            },
            'warmingTray.deactivateAt': function () {
                if (this.warmingTray.deactivateAt <= this.warmingTray.activateAt) {                    
                    this.warmingTray.activateAt = timemanager.addMinutes(new Date(this.warmingTray.deactivateAt.getTime()), -5);
                }
            }
        }
    };

</script>

<style scoped>
</style>